/* src/app/shared/components/custom-date-picker/custom-date-picker.component.scss */
.date-picker-container {
  display: flex;
  gap: 16px;
}
.date-input {
  flex: 1;
}
/*# sourceMappingURL=custom-date-picker.component.css.map */
